import React from "react";
import ButtonMflPlayer from "shared/components/buttons/ButtonMflPlayer.js";
import "./Item.css";
import MiscOverall from "shared/components/misc/MiscOverall.js";
import { useIsSmall } from "shared/components/utils/UtilIsSmall.js";

const ItemRowPlayerWithEnergy = ({ p, isSelected }) => {
  const { ref: containerRef, isSmall } = useIsSmall(400);

  return (
    <div
      ref={containerRef}
      className={`Item ItemRowPlayerWithEnergy no-hover w-100 ${isSelected ? "selected" : ""}`}
      style={{ backgroundColor: "transparent" }}
    >
      <div className={`d-flex ${isSmall ? "flex-column" : "flex-row"} flex-fill pb-1 pb-md-0`}>
        <div className={`d-flex flex-row ${isSmall ? "" : "flex-basis-200"}`}>
          <i className="bi bi-person-badge-fill me-1" />

          <div className="d-flex flex-fill min-width-0">
            <div className="text-truncate w-100">
              {p?.metadata?.firstName} {p?.metadata?.lastName}
            </div>
          </div>
        </div>
        <div className="d-flex flex-row flex-fill">
          <div className="d-flex flex-basis-40">
            <MiscOverall player={p.metadata} />
          </div>

          <div className="d-flex flex-basis-120">{p.metadata.positions.join(", ")}</div>

          <div className="d-flex flex-fill justify-content-end">{Math.floor(p.energy / 100)}%</div>
        </div>
      </div>
    </div>
  );
};

export default ItemRowPlayerWithEnergy;
